// import material from 'vue-material/material'
import MdTable from './MdTable.vue';
import MdTableToolbar from './MdTableToolbar.vue';
import MdTableEmptyState from './MdTableEmptyState.vue';
import MdTableRow from './MdTableRow.vue';
import MdTableHead from './MdTableHead.vue';
import MdTableCell from './MdTableCell.vue';
// @ts-ignore
import MdTablePagination from './MdTablePagination.vue';
import { App } from 'vue';

export const mdTableRegistComponent = function (app: App) {
  console.log('mdTableRegistComponent');
  app.component(MdTable.name, MdTable);
  app.component(MdTableToolbar.name, MdTableToolbar);
  app.component(MdTableEmptyState.name, MdTableEmptyState);
  app.component(MdTableRow.name, MdTableRow);
  app.component(MdTableHead.name, MdTableHead);
  app.component(MdTableCell.name, MdTableCell);
  app.component(MdTablePagination.name, MdTablePagination);
};

// export default Vue => {
//   material(Vue)
//   Vue.component('MdTable', MdTable)
//   Vue.component(MdTableToolbar.name, MdTableToolbar)
//   Vue.component(MdTableEmptyState.name, MdTableEmptyState)
//   Vue.component(MdTableRow.name, MdTableRow)
//   Vue.component(MdTableHead.name, MdTableHead)
//   Vue.component(MdTableCell.name, MdTableCell)
//   Vue.component(MdTablePagination.name, MdTablePagination)
// }
